'use es6';

import { NavMarker } from 'react-rhumb';
import I18n from 'I18n';
import UIImage from 'UIComponents/image/UIImage';
import imageUrl from 'bender-url!FileManagerImages/images/empty-folder.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FolderNotFound() {
  return /*#__PURE__*/_jsxs("div", {
    className: "folder-not-found",
    "data-test-id": "folder-not-found",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "FOLDER_NOT_FOUND"
    }), /*#__PURE__*/_jsx(UIImage, {
      className: "m-y-10",
      width: 100,
      src: imageUrl,
      responsive: false
    }), /*#__PURE__*/_jsx("h4", {
      children: I18n.text('FileManagerDashboard.folderNotFound.message')
    }), /*#__PURE__*/_jsx("p", {
      children: I18n.text('FileManagerDashboard.folderNotFound.hint')
    })]
  });
}